import React, { useRef, useEffect } from 'react';

function useOutsideAlerter(ref, setShowCart) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      console.log('CLicked outsite');
      if (ref.current && !ref.current.contains(event.target)) {
        setShowCart(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

/**
 * Component that alerts if you click outside of it
 */
export default function ClickOutSideDiv(props) {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props.setShowCart);

  return <div ref={wrapperRef}>{props.children}</div>;
}
